import React from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { setMainImageIndex } from '../../store/feedbackSearchFeed';

import ProductsCarousel from '../ProductsCarousel';

const FeedbackTemplateMainImage = () => {
  const dispatch = useDispatch();
  const currentItem = useSelector((store) => store.feedbackSearchFeed.currentItem);
  const mainImageIndex = useSelector((store) => store.feedbackSearchFeed.mainImageIndex);

  if (!currentItem) {
    return null;
  }

  return (
    <ProductsCarousel
      images={currentItem.images}
      mediumImages={currentItem.medium_images}
      largeImages={currentItem.large_images}
      mainImageIndex={mainImageIndex}
      onClick={(idx) => dispatch(setMainImageIndex(idx))}
      align="left"
    />
  );
};

export default FeedbackTemplateMainImage;
